export default {
    namespaced: true,
    state: {
        examId: -1, //試題序號
        examTimeEndId: -1,
        oNum: 0, //答對題目
        timeing: 0, //測驗經過時間
        timerId: 0
    },
    mutations: {
        examTimeEndId(state, val) {
            state.examTimeEndId = val
        },
        startExam(state) {
            state.oNum = 0
            state.examId = 0
            state.examTimeEndId = 0
        },
        nextExam(state) {
            state.examId++
        },
        timeEndExam(state) {
            state.examTimeEndId++
        },
        endExam(state) {
            state.examId = -1
            state.examTimeEndId = -1
        },
        addoNum(state, val) {
            state.oNum += val
        },
        timeing(state, val) {
            state.timeing = val
        },
        timerId(state, val) {
            state.timerId = val
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/exam.js